module.exports = __webpack_public_path__ + "img/查询.75735de6.png";